module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }